export const regioner = [
  { nr: 81, name: "Nord" },
  { nr: 82, name: "Midtjylland" },
  { nr: 83, name: "Syddanmark" },
  { nr: 84, name: "Hovedstaden" },
  { nr: 85, name: "Sjælland" },
  { nr: 90, name: "Grønland" },
];
